var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C69499F0-C886-4B7D-AA7C-C6109FEA05EC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.303144182
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-329.000000, -560.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search3",
    transform: "translate(314.000000, 545.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5762712,28.1608549 L34.7288136,33.2902137 C35.0903955,33.6501687 35.0903955,34.3700787 34.7288136,34.7300337 C34.3672316,35.0899888 33.6440678,35.0899888 33.2824859,34.7300337 L28.1299435,29.6006749 C24.9661017,32.12036 20.2655367,31.8503937 17.3728814,28.8807649 C14.2090395,25.7311586 14.2090395,20.511811 17.3728814,17.3622047 C20.5367232,14.2125984 25.779661,14.2125984 28.9435028,17.3622047 C31.9265537,20.3318335 32.1073446,24.9212598 29.5762712,28.1608549 L29.5762712,28.1608549 Z M27.2197802,27.2197802 C29.5934066,24.8461538 29.5934066,21.1538462 27.2197802,18.7802198 C24.8461538,16.4065934 21.1538462,16.4065934 18.7802198,18.7802198 C16.4065934,21.1538462 16.4065934,24.8461538 18.7802198,27.2197802 C21.1538462,29.5934066 24.8461538,29.5934066 27.2197802,27.2197802 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.86fc9cdd90b2662af19083a9045c2572.svg";
export { ForwardRef as ReactComponent };